import { createFileRoute } from "@tanstack/react-router";
import { CollectionsPage } from "@/components/collections/collections-page.js";

export const Route = createFileRoute("/_authenticated/catalog/collections")({
  component: CollectionsPage,
});
